import React, { useState, useEffect } from 'react';
import { Avatar, Badge, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useUserStatuses } from '../../SocketContext';

// Styled Badge component with online/offline status indicator
const StatusBadge = styled(Badge)(({ theme, isOnline }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: isOnline ? '#44b700' : '#ff0000',
    color: isOnline ? '#44b700' : '#ff0000',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}));

const AvatarWithStatus = ({ user, src, alt, sx = {}, onClick }) => {
  const [isOnline, setIsOnline] = useState(user?.isOnline || false);
  const userStatuses = useUserStatuses();
  
  useEffect(() => {
    // Initialize status from user prop
    if (user) {
      // Check if we have a status update from the context
      if (userStatuses.has(user._id)) {
        setIsOnline(userStatuses.get(user._id));
      } else {
        // Otherwise use the status from the user object
        setIsOnline(user.isOnline || false);
      }
    }
  }, [user, userStatuses]);

  const avatarSrc = src || (user && user.avatarUrl) || '/default-avatar.png';
  const avatarAlt = alt || (user && user.login) || 'User';

  return (
    <Box sx={{ position: 'relative' }}>
      <StatusBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant="dot"
        isOnline={isOnline}
      >
        <Avatar 
          src={avatarSrc} 
          alt={avatarAlt}
          onClick={onClick}
          sx={{ cursor: onClick ? 'pointer' : 'default', ...(sx || {}) }}
        />
      </StatusBadge>
    </Box>
  );
};

export default AvatarWithStatus; 